export default __webpack_public_path__ + "static/media/40cd5767b11300ec4a993cd018211b801598743644034.1fbefda2.webp";